const segments = {
  second: 1000,
  minute: 60 * 1000,
  hour: 60 * 1000 * 60,
  day: 24 * 60 * 1000 * 60,
  week: 7 * 24 * 60 * 1000 * 60,
  month: 30 * 24 * 60 * 1000 * 60,
  year: 365 * 24 * 60 * 1000 * 60
}

export default (dateString) => {
  const ts = Date.now() - new Date(dateString).getTime()
  let lastSegment = 'second'

  if (ts >= 0 && ts < 1000) {
    return 'just now'
  }

  for (const key in segments) {
    if (ts < segments[key]) {
      return `${Math.round(ts / segments[lastSegment])}${lastSegment[0]}`
    }

    lastSegment = key
  }
}



// WEBPACK FOOTER //
// ./app/lib/timeago.js